import { useGetSelectedLogbooksReasons } from '../../api/LogbookApi';

export default function GetCurrentReasons(props) {
    const { selectedLogbooks, setCurrentReasons } = props;
    useGetSelectedLogbooksReasons(selectedLogbooks, setCurrentReasons);
}
